function isHorizontalOrientation() {
	if (window.innerWidth > window.innerHeight) return true;

	return false;
}

export { isHorizontalOrientation };



// WEBPACK FOOTER //
// ./src/js/utils/isHorizontalOrientation.js